import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { colors } from '../../constants'

export const Link = styled.a`
    color: ${colors.blue};
    cursor: pointer;
    text-decoration: none;
`

const ExternalLink = ({ children, href }) => <Link href={href}>{children}</Link>

ExternalLink.propTypes = {
    children: PropTypes.node.isRequired,
    href: PropTypes.string,
}

export default ExternalLink
